import React from "react";
import ErrorState from "../ErrorState/ErrorState";

interface AppCrashFallbackProps {
  error: Error;
  resetError: () => void;
}

/**
 * Rendered by the top-level error boundary when a render throws. Datadog's
 * `ErrorBoundary` has already reported the error by the time this mounts.
 */
const AppCrashFallback: React.FC<AppCrashFallbackProps> = ({
  error,
  resetError,
}) => (
  <ErrorState
    error={error}
    onRetry={resetError}
    title="Something went wrong"
    description="The page could not be displayed. Try again, and contact Unruly support at accounts@unrulycorp.com if the problem persists."
  />
);

export default AppCrashFallback;
